var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1432,
    height: 1430,
    viewBox: "0 0 1432 1430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M914.203 31.1949C1067.76 -19.8409 1203.93 5.27042 1259.71 16.6772C1403 46.4784 1504.58 98.9353 1572.82 223.299C1649.35 362.981 1601.93 537.32 1650.24 689.601C1677.26 774.861 1739.74 837.281 1776.84 917.312C1823 1016.41 1809.63 1106.15 1760.1 1201.86C1704.38 1309.47 1626.26 1373.61 1504.88 1401.49C1389 1428.11 1277.28 1445.67 1162.48 1409.16C1049.09 1372.96 957.363 1299.88 847.17 1255.54C754.41 1218.33 629.665 1203.74 529.182 1216.69C279.643 1248.44 10.1179 1272.13 -195.585 1101.24C-417.099 917.333 -433.447 605.934 -232.425 400.592C-98.8638 264.36 114.214 121.644 333.942 148.205C458.756 163.298 466.561 216.478 571.332 207.318C716.115 194.748 733.297 91.3737 914.203 31.1949Z",
    fill: "#E9F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.1c640288d00de57056f983b0c6eb1b5e.svg";
export { ForwardRef as ReactComponent };